var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvancedFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2_00000021114515958060265540000010647482734041147812_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 98.4 98.4",
    style: {
      enableBackground: "new 0 0 98.4 98.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#125FDE;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1307"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_309",
    className: "st0",
    cx: 49.2,
    cy: 49.2,
    r: 49.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1296"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_307",
    className: "st1",
    cx: 34.2,
    cy: 53.5,
    r: 8.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_137",
    className: "st1",
    x1: 34.2,
    y1: 74.9,
    x2: 34.2,
    y2: 62.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_138",
    className: "st1",
    x1: 34.2,
    y1: 44.9,
    x2: 34.2,
    y2: 21.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1297"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_308",
    className: "st1",
    cx: 62.1,
    cy: 42.8,
    r: 8.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_139",
    className: "st1",
    x1: 62.1,
    y1: 74.9,
    x2: 62.1,
    y2: 51.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_140",
    className: "st1",
    x1: 62.1,
    y1: 34.2,
    x2: 62.1,
    y2: 21.4
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedFilter);
export default __webpack_public_path__ + "static/media/advancedFilter.b8118e93410e99290658d963c3f38a0a.svg";
export { ForwardRef as ReactComponent };